import { render, staticRenderFns } from "./productSelect.vue?vue&type=template&id=b5eca126&scoped=true&"
import script from "./productSelect.vue?vue&type=script&lang=js&"
export * from "./productSelect.vue?vue&type=script&lang=js&"
import style0 from "./productSelect.vue?vue&type=style&index=0&id=b5eca126&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5eca126",
  null
  
)

export default component.exports